/**
 * Asynchronously loads the component for NotFoundPage
 */

import { lazyLoad } from 'utils/loadable';

export const SyncEntityProductObjectPage = lazyLoad(
  () => import('./index'),
  module => module.SyncEntityProductObjectPage
);
